import { Instagram, MessageCircle, Phone, MapPin, Mail } from "lucide-react";
import {
  INSTAGRAM_URL,
  TIKTOK_URL,
  PHONE_DISPLAY,
  WHATSAPP_NUMBER,
  EMAIL,
  LANDLINES,
  waLink,
  DEFAULT_WA_MSG,
} from "../data/content";

const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.9 2.9 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.3 0 .58.05.85.13V9.4a6.33 6.33 0 0 0-.85-.05A6.34 6.34 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.04-.1z" />
  </svg>
);

export const Footer = () => (
  <footer className="relative border-t border-white/10 bg-ink py-14">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col lg:flex-row items-center lg:items-start justify-between gap-10">
        <div className="text-center lg:text-left">
          <div className="flex items-center justify-center lg:justify-start gap-3">
            <img
              src="/images/logo.webp"
              alt="Gold Service"
              className="h-12 w-12 rounded-full object-cover ring-1 ring-gold/50"
            />
            <div>
              <p className="font-display font-bold text-lg">
                Gold <span className="gold-text">Service</span>
              </p>
              <p className="text-[10px] uppercase tracking-[0.22em] text-mist">
                Controle Integrado de Ambientes
              </p>
            </div>
          </div>
          <a
            data-testid="footer-address-link"
            href="https://www.google.com/maps/search/?api=1&query=Rua+Japur%C3%A1,+570+-+Amazonas,+Contagem+-+MG"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center justify-center lg:justify-start gap-2 text-sm text-mist hover:text-gold-light transition-colors"
          >
            <MapPin className="h-4 w-4 text-gold shrink-0" />
            Rua Japurá, 570 — Amazonas, Contagem/MG
          </a>
        </div>

        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-mist mb-4">
            Siga a Gold
          </p>
          <div className="flex items-center gap-3">
            <a
              data-testid="social-link-instagram"
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram da Gold Service"
              className="flex h-12 w-12 items-center justify-center rounded-full border border-white/15 text-zinc-200 transition-all duration-300 hover:border-gold hover:text-gold hover:-translate-y-1"
            >
              <Instagram className="h-5 w-5" />
            </a>
            <a
              data-testid="social-link-tiktok"
              href={TIKTOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok da Gold Service"
              className="flex h-12 w-12 items-center justify-center rounded-full border border-white/15 text-zinc-200 transition-all duration-300 hover:border-gold hover:text-gold hover:-translate-y-1"
            >
              <TikTokIcon className="h-5 w-5" />
            </a>
            <a
              data-testid="social-link-whatsapp"
              href={waLink(DEFAULT_WA_MSG)}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp da Gold Service"
              className="flex h-12 w-12 items-center justify-center rounded-full border border-white/15 text-zinc-200 transition-all duration-300 hover:border-gold hover:text-gold hover:-translate-y-1"
            >
              <MessageCircle className="h-5 w-5" />
            </a>
          </div>
          <p className="mt-3 text-xs text-mist">@goldservicemg</p>
        </div>

        <div className="text-center lg:text-right">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-mist mb-3">
            Fale com a Gold
          </p>
          <a
            data-testid="footer-phone-link"
            href={`tel:+${WHATSAPP_NUMBER}`}
            className="inline-flex items-center gap-2 font-display text-xl font-bold text-gold-light hover:text-gold transition-colors"
          >
            <Phone className="h-5 w-5" />
            {PHONE_DISPLAY}
          </a>
          <p className="mt-2 text-xs text-mist">Atendimento todos os dias, 24h</p>
          <a
            data-testid="footer-email-link"
            href={`mailto:${EMAIL}`}
            className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-mist hover:text-gold-light transition-colors"
          >
            <Mail className="h-4 w-4 text-gold" />
            {EMAIL}
          </a>
          <div className="mt-3 flex flex-col items-center lg:items-end gap-1.5">
            {LANDLINES.map((l, i) => (
              <a
                key={l.tel}
                data-testid={`footer-landline-${i}`}
                href={`tel:${l.tel}`}
                className="inline-flex items-center gap-2 text-sm text-mist hover:text-gold-light transition-colors"
              >
                <Phone className="h-3.5 w-3.5 text-gold" />
                Fixo {l.display}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-12 border-t border-white/5 pt-6 text-center text-[11px] text-zinc-600">
        © {new Date().getFullYear()} Gold Service — Controle Integrado de
        Ambientes. Todos os direitos reservados Site Desenvolvido por {"Matheus Mello"}.
      </div>
    </div>
  </footer>
);